<template>
  <RevInfoBlock
    class="pt-20 pb-8"
    :icon="contextualCallout.icon || fallbackIcon"
    :title="contextualCallout.text"
    :variant="contextualCallout.type"
  />
</template>

<script lang="ts" setup>
import { type Component, computed } from 'vue'

import { RevInfoBlock } from '@ds/components/InfoBlock'
import { IconInfo } from '@ds/icons/IconInfo'

const props = defineProps<{
  contextualCallout: {
    text: string
    type: 'warning'
    icon: Component | null
  }
}>()

const fallbackIcon = computed(() => {
  if (!props.contextualCallout.icon) {
    return IconInfo
  }

  return props.contextualCallout.icon
})
</script>
